import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import './home.css';
import Header from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';
import Seo from '../components/Seo';
import { images } from '../config/imagePaths';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function Home() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  const [activeTestimonial, setActiveTestimonial] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.4 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const imageData = [
    {
      id: 0,
      src: images.home.homeImage,
      label: 'Who Are We?',
      link: '/about',
    },
    {
      id: 1,
      src: images.home.publicSpeaking,
      label: 'Public Speaking',
      link: '/public-speaking',
    },
    {
      id: 2,
      src: images.home.digitalMarketingCarousel,
      label: 'Digital Marketing',
      link: '/digital-marketing',
    },
    {
      id: 3,
      src: images.home.webDesign,
      label: 'Web Design',
      link: '/web-design',
    },
    {
      id: 4,
      src: images.home.contact,
      label: 'Contact Us',
      link: '/contact',
    },
  ];

  const testimonials = [
    {
      short: "“Alison is a great teacher... I highly recommend Alison...”",
      full: `“Alison is a great teacher. She has really helped me to develop my public speaking skills. 
      She really knows what she's talking about and has a real passion for what she does. I highly recommend 
      Alison to anybody that is preparing for an interview, a public speaking speech or if you just want to develop your interpersonal skills in general.” — Edvardas C.`
    },
    {
      short: "“AOK Communications provided a top rate excellent service... highly recommend...”",
      full: `“AOK Communications provided a top rate excellent service in digital marketing to my business from extensive SEO across my website to designing high quality 
      promotional materials to promote my business. The customer service was top notch with delivery on time every time. I have no hesitation in recommending the services of AOK Marketing."  — Aideen S.`
    },
    {
      short: "“No matter how confident I may seem... Alison was always there...”",
      full: `“No matter how confident and outspoken I may seem as of now, I cant take full credit for how far I have come with with my ongoing public speaking journey. When I was overwhelmed or didn't 
      want to give something a go, Alison was always there with her wise words to encourage me to make that step, and she is part of the reason as to why I am where I am today. She takes her time and 
      makes sure that you are out of your comfort zone, this is something that I really appreciated. She gives you the push when you need it but also gives you enough space to let you find your feet.” — Magdalene O.`
    }
  ];

  return (
    <>
      <Seo
        title="Home"
        description="AOK Communications empowers people and businesses through public speaking, digital marketing, and web design."
      />
      <Header />

      <section className="hero-split" ref={sectionRef}>
        <div
          className="hero-bg"
          style={{ backgroundImage: `url(${images.home.background})` }}
        />
        <div className="hero-overlay" />
        <div className="hero-text-scroll hero-text-animate">
          <div className="hero-buttons">
            <Link to="/about" className="hero-btn">Who Are We</Link>
            <Link to="/services" className="hero-btn">What We Do</Link>
          </div>
        </div>
      </section>

      <section className="business-section reveal">
        <div className="business-inner">
          <h3>Elevate your Business</h3>
          <p>
            At AOK Communications, we use a combination of coaching and cutting-edge digital marketing
            strategies to help you and your business reach their goals!
          </p>
          <p className="business-inner">
            We take the everyday pressure of digital marketing and social media management off your
            hands, while implementing innovative techniques to increase your sales. Avail of our free
            consultations here!
          </p>
          <Link to="/contact">
            <button className="contact-button hover-lift">Contact Us</button>
          </Link>
        </div>
      </section>

      <section className="carousel-wrapper">
        <div className="carousel-outer">
          <button className="custom-prev" aria-label="Previous slide">&#8249;</button>

          <div className="carousel-inner">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={3}
              spaceBetween={30}
              navigation={{
                prevEl: '.custom-prev',
                nextEl: '.custom-next',
              }}
              pagination={{
                el: '.custom-dots',
                clickable: true,
              }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              loop
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 }
              }}
              className="image-carousel"
            >
              {imageData.map((img) => (
                <SwiperSlide key={img.id}>
                  <div className="carousel-card">
                    <div className="img-zoom-wrap">
                      <img src={img.src} alt={img.label} />
                    </div>
                    <div className="image-overlay-center">{img.label}</div>
                    <div className="overlay-btn-wrap">
                      <Link className="overlay-btn" to={img.link}>View</Link>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <button className="custom-next" aria-label="Next slide">&#8250;</button>
        </div>

        <div className="custom-dots"></div>
      </section>

      <section className="testimonials reveal">
        <div className="testimonials-inner">
          <h3>What Our Clients Say</h3>
          <div className="stagger-children">
            {testimonials.map((t, i) => (
              <div
                key={i}
                className={`testimonial testimonial-expand ${activeTestimonial === i ? 'expanded' : ''}`}
                onClick={() => setActiveTestimonial(activeTestimonial === i ? null : i)}
                style={{ cursor: 'pointer' }}
              >
                <p>{activeTestimonial === i ? t.full : t.short}</p>
                {activeTestimonial === i && (
                  <span className="collapse-hint">(Click to collapse)</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="spacer"></div>
      <Footer />
    </>
  );
}

export default Home;
